/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class PersonApiConfiguration {
  rootUrl: string = '/';
}

/**
 * Parameters for `PersonApiModule.forRoot()`
 */
export interface PersonApiConfigurationParams {
  rootUrl?: string;
}
